import React, { Component } from 'react';
import { CookiesProvider } from 'react-cookie';
import Banner from './Banner';
import Questionnaire from './Questionnaire';
import { Card, CardHeader, CardBody } from 'reactstrap';
import Footer from '../common/Footer';

export class CovidAsymptomaticTestingQuestionnaire extends Component {

    render() {
        return (<>
            <Card>
                <CardHeader className="questionnaire-banner-aerial">
                    <Banner />
                </CardHeader>
                <CardBody>
                    <CookiesProvider>
                        <Questionnaire {...this.props} />
                    </CookiesProvider>
                </CardBody>
            </Card>
            <Footer />
            </>
        );
    }
}
